if (!customElements.get('postcode-checker')) {
  class PostcodeChecker extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.result = this.querySelector('.postcode-checker__result');
      this.areas = (this.dataset.ukAreas || '').split(' ');
      try {
        this.zones = JSON.parse(this.querySelector('[data-zones]').textContent);
      } catch (e) {
        this.zones = [];
      }
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.check(this.input.value);
      });
    }

    // Returns { area, district } for a full postcode or an outward code, or null.
    parse(value) {
      let code = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(code)) code = code.slice(0, -3);
      const match = code.match(/^([A-Z]{1,2})(\d{1,2})([A-Z]?)$/);
      if (!match) return null;
      return { outward: code, area: match[1], district: parseInt(match[2], 10) };
    }

    // Rules: "EH" (whole area), "FK1" (one district), "FK1-FK14" or "FK1-14" (district range).
    matchesRule(rule, postcode) {
      const parts = rule.toUpperCase().replace(/\s/g, '').split('-');
      const from = parts[0].match(/^([A-Z]{1,2})(\d{1,2})?$/);
      if (!from || from[1] !== postcode.area) return false;
      if (from[2] === undefined) return true;
      const start = parseInt(from[2], 10);
      if (parts.length === 1) return postcode.district === start;
      const end = parseInt(parts[1].replace(/^[A-Z]+/, ''), 10);
      return postcode.district >= start && postcode.district <= end;
    }

    findZone(postcode) {
      const specific = this.zones.find(
        (zone) => zone.prefixes.length && zone.prefixes.some((rule) => this.matchesRule(rule, postcode))
      );
      return specific || this.zones.find((zone) => !zone.prefixes.length);
    }

    money(value) {
      const amount = Number(value);
      return '£' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
    }

    check(value) {
      const postcode = this.parse(value);
      if (!postcode) {
        return this.show('error', "<p>Please enter a UK postcode, for example <strong>NR12</strong> or <strong>NR12 9DA</strong>.</p>");
      }
      const zone = this.areas.includes(postcode.area) ? this.findZone(postcode) : null;
      if (!zone || zone.contactOnly) {
        return this.show(
          'warning',
          `<p><strong>${postcode.outward}</strong>: please <a href="/pages/contact">contact us</a> before ordering and we'll confirm whether we can deliver to you.</p>`
        );
      }
      const lines = [`<li>Delivery: <strong>${this.money(zone.charge)}</strong></li>`];
      if (zone.freeOver) lines.push(`<li><strong>FREE delivery</strong> on orders over ${this.money(zone.freeOver)}</li>`);
      if (Number(zone.minimum) > 0) lines.push(`<li>Minimum order: ${this.money(zone.minimum)}</li>`);
      if (zone.note) lines.push(`<li>${zone.note}</li>`);
      this.show(
        'success',
        `<p class="postcode-checker__zone"><strong>Good news, we deliver to ${postcode.outward}</strong> (${zone.name})</p>
         <ul>${lines.join('')}</ul>
         <p class="postcode-checker__small">Charges are confirmed at checkout. FREE Click &amp; Collect from Stalham, no minimum spend.</p>`
      );
    }

    show(state, html) {
      this.result.hidden = false;
      this.result.dataset.state = state;
      this.result.innerHTML = html;
    }
  }
  customElements.define('postcode-checker', PostcodeChecker);
}

// Directory regions: collapsed on mobile, open on larger screens.
document.querySelectorAll('.location-directory__region').forEach((region) => {
  if (window.matchMedia('(max-width: 749px)').matches) region.removeAttribute('open');
});

// Long extra content: collapse with a "Read more" button.
document.querySelectorAll('.location-content__body').forEach((body) => {
  // This file can be included by more than one section, so only set up once.
  if (body.classList.contains('is-collapsible') || body.scrollHeight < 900) return;
  body.classList.add('is-collapsible', 'is-collapsed');
  body.id = body.id || 'LocationContent';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button button--secondary location-content__toggle';
  button.setAttribute('aria-controls', body.id);
  button.setAttribute('aria-expanded', 'false');
  button.textContent = 'Read more';
  button.addEventListener('click', () => {
    const collapsed = body.classList.toggle('is-collapsed');
    button.setAttribute('aria-expanded', String(!collapsed));
    button.textContent = collapsed ? 'Read more' : 'Show less';
    if (collapsed) body.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  body.after(button);
});
